module.exports = __webpack_public_path__ + "img/ewm.740221c0.png";